module.exports = function (app) {
    app.directive('loginBox', ['brand', '$cookies', 'session', function (brand, $cookies, session) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/loginBox.html'),
            scope: {
                loggingIn: '=',
                showInvalidUserPass: '=',
                errorText: '=',
                loginInfo: '=',
                loginBoxClass: '=?',
                forgotAction: '&',
                oAuthMfaRedirect: '&'
            },
             controller: 'loginBoxController'
        };
    }]);
    app.controller('loginBoxController', ['$scope', 'brand', '$cookies', 'session', function ($scope, brand, $cookies, session) {
        //smart message section check
        $scope.isNDBCBS = brand.current.sharedBrandCode.toLowerCase() === "ndbcbs" ? true : false;
        $scope.smartMessage = (brand.current.sharedBrandCode.toLowerCase() === 'mincr' || brand.current.sharedBrandCode.toLowerCase() === 'ndbcbs' || brand.current.sharedBrandCode.toLowerCase() === 'wybcbs') ? true : false;
        if (brand.current.sharedBrandCode.toLowerCase() === 'ndbcbs') {
            $scope.whyRegisterHref = "#";
            $scope.registrationText = "Remember my username";
            $scope.showforNDWY = true;
        }
        else if (brand.current.sharedBrandCode.toLowerCase() === 'wybcbs') {
            $scope.showforNDWY = true;

            $scope.whyRegisterHref = "https://www.bcbswy.com/members/whatsinside/";
            $scope.registrationText = "Remember my username";
        }
        else {
            $scope.whyRegisterHref = "https://www.bluecrossmn.com/hosted/site-change-info";
            $scope.registrationText = "Remember your username";
        }
        $scope.siteOutage = session.data.siteOutage;
        $scope.loginInfo.username = $cookies.get('rememberUsername');
        $scope.loginInfo.rememberUsername = Boolean($scope.loginInfo.username);

        $scope.$watch('loginInfo.rememberUsername', function (v) {
            if (v) {
                $cookies.put('rememberUsername', $scope.loginInfo.username);
            }
        });

        $scope.$watch('loginInfo.username', function () {
            if ($scope.loginInfo.rememberUsername) {
                $cookies.put('rememberUsername', $scope.loginInfo.username);
            }
        });

       
    }]);
};